export default "__VITE_ASSET__BBJft_6q__"